import React, { useCallback } from 'react';
import { Stack } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import PhoneIcon from '@mui/icons-material/PhoneIphone';

import { Button, Card, Typography } from '@occc/ui-design-system';
import { TextField } from '@occc/ui-design-system';

export type SendTestMessageSectionProps = {
  membershipUuid: string;
  onMembershipUuidChange: (uuid: string) => void;
  canSendSms?: boolean;
  canSendPush?: boolean;
  onSendClick?: (type: 'sms' | 'push') => void;
};

export const SendTestMessageSection = (props: SendTestMessageSectionProps) => {
  const { membershipUuid, onMembershipUuidChange, canSendSms, canSendPush, onSendClick } = props;

  const onSendSmsClick = useCallback(() => {
    onSendClick?.('sms');
  }, [onSendClick]);

  const onSendPushClick = useCallback(() => {
    onSendClick?.('push');
  }, [onSendClick]);

  const onMemberUuidChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onMembershipUuidChange(event.target.value);
    },
    [onMembershipUuidChange],
  );

  return (
    <Card sx={{ padding: 3 }}>
      <Typography variant='subtitle1'>Test Message</Typography>
      <Stack spacing={2} direction='row' mt={2} alignItems='center'>
        <TextField
          value={membershipUuid}
          onChange={onMemberUuidChange}
          inputProps={{ maxLength: 36 }}
          label='Member UUID'
          sx={{ width: 504 }}
        />
        {/* Width is purposely hardcoded, so both buttons have equal size */}
        <Button
          variant='contained'
          startIcon={<SendIcon />}
          sx={{ width: 160, flexShrink: 0 }}
          disabled={!canSendSms}
          onClick={onSendSmsClick}
        >
          Send SMS
        </Button>
        <Button
          variant='contained'
          startIcon={<PhoneIcon />}
          sx={{ width: 160, flexShrink: 0 }}
          disabled={!canSendPush}
          onClick={onSendPushClick}
        >
          Send Push
        </Button>
      </Stack>
    </Card>
  );
};
